module.exports = __webpack_public_path__ + "img/DS-J-13.a4e6164a.svg";